module.exports = __webpack_public_path__ + "static/media/1.6100f45c.jpg";